var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import IVueDialog from "@/interface/IVueDialog";
import AccoutCheckService from '../../../api/AccoutCheckService';
import { Loading } from 'element-ui';
import RechargeDialog from '../../../page/serviceInterface/components/RechargeDialog';
import GlobalVue from "../../../globalVue";
import ServiceInterface from '../../../page/serviceInterface/Index.vue';
import GenerateInvoice from './GenerateInvoice.vue';
import { cloneDeep } from 'lodash';
import { saveAs } from 'file-saver';
import EAccountStatus from "../../../enum/EAccountStatus";
var InvoiceInfoDialog = (function (_super) {
    __extends(InvoiceInfoDialog, _super);
    function InvoiceInfoDialog() {
        var _this_1 = _super !== null && _super.apply(this, arguments) || this;
        _this_1.pdfDialogVisible = false;
        _this_1.pdfDialogUrl = '';
        _this_1.type = '';
        _this_1.renameDialogVisible = false;
        _this_1.currentInvoice = null;
        _this_1.renameText = '';
        _this_1.currentDocumentId = null;
        _this_1.invoiceList = [];
        _this_1.isShowInvoice = false;
        _this_1.limit = 30;
        _this_1.maxSize = 5;
        _this_1.statusList = EAccountStatus;
        _this_1.is_open_check = false;
        _this_1.is_open_verify = false;
        _this_1.timer = null;
        _this_1.isFirstLoad = true;
        _this_1.previewImg = '';
        _this_1.loadingGetThirdInvoice = false;
        _this_1.isEdit = false;
        _this_1.totalMoney = 0;
        _this_1.invoiceForm = {};
        _this_1.parentPageAuth = {};
        _this_1.rules = {
            name: [
                { required: true, message: '请输入公司抬头', trigger: 'blur' }
            ],
            taxnumber: [
                { required: true, message: '请输入公司税号', trigger: 'blur' }
            ]
        };
        return _this_1;
    }
    InvoiceInfoDialog.prototype.getThirdInvoice = function () {
        var _this_1 = this;
        console.log('getThirdInvoice>>>');
        if (!this.detail.order_id) {
            this.$message.warning('请先保存对账单后再执行开票');
            return;
        }
        if (this.loadingGetThirdInvoice) {
            return;
        }
        this.loadingGetThirdInvoice = true;
        this.service.getThirdInvoice({
            order_id: this.detail.order_id
        }).then(function (res) {
            console.log('getThirdInvoice res>>>', res);
            if (res.data.code === 0) {
                _this_1.$message.success(res.data.msg || '获取百望云发票成功');
                _this_1.getOrderDocumentList();
            }
            else {
                _this_1.$message.error(res.data.msg || '获取百望云发票失败');
            }
        })
            .catch(function (err) {
            _this_1.$message.error(err.msg || err.message);
        }).finally(function () {
            _this_1.loadingGetThirdInvoice = false;
        });
    };
    InvoiceInfoDialog.prototype.showGenerateInvoice = function () {
        if (!this.detail.order_id) {
            return this.$message.warning('请先保存对账单后再执行开票');
        }
        var instance = this.$dialog(GenerateInvoice, {
            data: {
                id: this.detail.order_id
            }
        }, {
            title: '发票开具',
            width: 440,
            height: 300,
            zIndex: 2000
        }).instance;
        instance.$on('close', function () {
            console.log('close>>>');
            instance.$destroy();
        });
    };
    InvoiceInfoDialog.prototype.previewImage = function (item) {
        var type = item.document_pic.slice(-3).toLowerCase();
        if (!['pdf', 'ofd'].includes(type)) {
            this.previewImg = item.document_pic;
            this.$refs.previewImg.showViewer = true;
        }
        else {
            this.pdfDialogUrl = item.document_pic;
            this.pdfDialogVisible = true;
        }
    };
    InvoiceInfoDialog.prototype.created = function () {
        var _this_1 = this;
        this.service = AccoutCheckService.getInstance();
        if (!this.invoice_info) {
            this.invoice_info = this.detail.invoice_info || {};
            this.invoice_status = this.detail.invoice_status || false;
            this.order_status_name = this.detail.order_status_name || '';
        }
        this.getOrderDocumentList();
        if (this.timer) {
            clearInterval(this.timer);
        }
        ;
        this.timer = setInterval(function () {
            _this_1.getOrderDocumentList();
        }, 3000);
    };
    InvoiceInfoDialog.prototype.isShowStatus = function () {
        var flag = false;
        if (this.detail.from_system == 1) {
            if (!this.invoice_info.taxnumber || this.invoice_info.taxnumber == null) {
                flag = false;
            }
            else {
                flag = true;
            }
        }
        else {
            flag = false;
        }
        ;
        return flag;
    };
    InvoiceInfoDialog.prototype.getLimit = function () {
        var num = this.limit - this.invoiceList.length;
        return num;
    };
    InvoiceInfoDialog.prototype.getInvoiceInfo = function (item) {
        if (item.check_status == 2 && item.check_result) {
            var result = JSON.parse(item.check_result);
            return {
                pretax_amount: result.pretax_amount && result.pretax_amount.value || 0,
                invoice_name: result.invoice_name && result.invoice_name.value || '',
                tax_amount: result.tax_amount && result.tax_amount.value || 0,
            };
        }
        return {
            pretax_amount: '',
            invoice_name: '--',
            tax_amount: '',
        };
    };
    InvoiceInfoDialog.prototype.getCompony = function (item) {
        if (this.is_open_check && item.check_status == 2) {
            if (item.check_result) {
                var result = JSON.parse(item.check_result);
                var str = result.buyer_name && result.buyer_name.value || '';
                if (result.buyer_tax_id && result.buyer_tax_id.value) {
                    str += "\uFF08" + result.buyer_tax_id.value + "\uFF09";
                }
                return str;
            }
        }
    };
    InvoiceInfoDialog.prototype.recharge = function (item) {
        var _this_1 = this;
        var apiType = item.check_status == 4 ? 1 : 2;
        var dialog = this.$dialog(RechargeDialog, {
            data: {
                api_type: apiType
            }
        }, {
            title: "服务充值",
            width: 610,
            height: 520,
            zIndex: 3000,
        });
        dialog.instance.$on("paySuccessEdit", function (res) {
            _this_1.getOrderDocumentList();
        });
    };
    InvoiceInfoDialog.prototype.handleSetting = function () {
        var _this_1 = this;
        this.getAuth('16007').then(function (pageAuth) {
            if (pageAuth && pageAuth.Auth) {
                GlobalVue.$emit("addTab", {
                    component: ServiceInterface,
                    title: '接口服务',
                    name: "service",
                    showExist: true,
                    cprops: {
                        service_setting: pageAuth.Auth.ServiceSetting,
                        is_open_service_dialog: true,
                    }
                });
                _this_1.$closeDialog();
            }
            else {
                _this_1.$message.error("接口服务页面没有查看权限");
            }
        });
    };
    InvoiceInfoDialog.prototype.refresh = function (item) {
        var _this_1 = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.refreshOrderDocument({
            order_document_id: item.document_id
        })
            .then(function (res) {
            loadingInstance.close();
            if (res.data.code === 0) {
                _this_1.$message.success('刷新发票成功');
                _this_1.getOrderDocumentList();
            }
            else {
                _this_1.$message.error(res.data.msg || '刷新发票失败');
            }
        })
            .catch(function (err) {
            loadingInstance.close();
            _this_1.$message.error(err.msg || err.message);
        });
    };
    InvoiceInfoDialog.prototype.isShowSetting = function (item) {
        var result = false;
        if (this.is_open_verify && !this.is_open_check) {
            result = true;
        }
        ;
        return result;
    };
    InvoiceInfoDialog.prototype.isShowCharge = function (item) {
        var result = false;
        if ((item.check_status == 4 || item.verify_status == 4) && item.need_charge != 0) {
            result = true;
        }
        return result;
    };
    InvoiceInfoDialog.prototype.isShowRefresh = function (item) {
        var result = false;
        if ([0, 3, 4].includes(item.check_status) || [3, 4].includes(item.verify_status)) {
            result = true;
        }
        return result;
    };
    InvoiceInfoDialog.prototype.isRename = function (item) {
        var flag = false;
        if (this.isShowReUpload(item)) {
            return false;
        }
        if (item.document_status == 1) {
            if (!this.is_open_check && !this.is_open_verify) {
                flag = true;
            }
            if (this.is_open_check && !this.is_open_verify) {
                if (item.check_status != 1) {
                    flag = true;
                }
            }
            if (this.is_open_verify && this.is_open_verify) {
                if (item.verify_status != 1) {
                    flag = true;
                }
            }
        }
        return flag;
    };
    InvoiceInfoDialog.prototype.isDel = function (item) {
        var flag = false;
        if (item.document_status == 6) {
            flag = true;
            return flag;
        }
        if (item.document_status == 1) {
            if (!this.is_open_check && !this.is_open_verify) {
                flag = true;
            }
            if (this.is_open_check && !this.is_open_verify) {
                if (item.check_status != 1) {
                    flag = true;
                }
            }
            if (this.is_open_verify && this.is_open_verify) {
                if (item.verify_status != 1) {
                    flag = true;
                }
            }
        }
        return flag;
    };
    InvoiceInfoDialog.prototype.isShowReUpload = function (item) {
        var flag = false;
        if ((item.check_status == 3 || item.verify_status == 3 || item.document_status == 6) && this.canEdit) {
            flag = true;
        }
        ;
        return flag;
    };
    InvoiceInfoDialog.prototype.isLoading = function (item) {
        var flag = false;
        if (this.is_open_check && item.check_status == 1) {
            flag = true;
        }
        if (this.is_open_verify && item.check_status == '2' && item.verify_status == 1) {
            flag = true;
        }
        return flag;
    };
    InvoiceInfoDialog.prototype.getImgUrl = function (item) {
        var str = '';
        if (item.source == 3) {
            switch (item.tax_status) {
                case 0:
                    str = 'static/image/invoice_success.png';
                    break;
                case '00':
                    str = 'static/image/invoice_success.png';
                    break;
                case 2:
                    str = 'static/image/invoice_error.png';
                    break;
                case 3:
                    str = 'static/image/invoice_error.png';
                    break;
                case 4:
                    str = 'static/image/invoice_error.png';
                    break;
                case 7:
                    str = 'static/image/invoice_info.png';
                    break;
                case 8:
                    str = 'static/image/invoice_error.png';
                    break;
                case 80:
                    str = 'static/image/invoice_info.png';
            }
        }
        if (item.document_status == 2) {
            str = 'static/image/invoice_success.png';
            return str;
        }
        if (item.document_status == 6) {
            str = 'static/image/invoice_error.png';
            return str;
        }
        if (!this.is_open_verify && !this.is_open_check) {
            str = 'static/image/invoice_success.png';
        }
        if (this.is_open_check) {
            switch (item.check_status) {
                case 0:
                    str = 'static/image/invoice_info.png';
                    break;
                case 1:
                    str = 'static/image/invoice_loading.png';
                    break;
                case 2:
                    str = 'static/image/invoice_success.png';
                    break;
                case 3:
                    str = 'static/image/invoice_info.png';
                    break;
                case 4:
                    str = 'static/image/invoice_info.png';
            }
        }
        if (this.is_open_verify && item.check_status == '2') {
            switch (item.verify_status) {
                case 0:
                    str = 'static/image/invoice_info.png';
                    break;
                case 1:
                    str = 'static/image/invoice_loading.png';
                    break;
                case 2:
                    str = 'static/image/invoice_success.png';
                    break;
                case 3:
                    str = 'static/image/invoice_info.png';
                    break;
                case 4:
                    str = 'static/image/invoice_info.png';
            }
        }
        if (this.is_open_verify && !this.is_open_check) {
            str = 'static/image/invoice_info.png';
        }
        return str;
    };
    InvoiceInfoDialog.prototype.statusColor = function (item) {
        var str = '';
        if (item.source == 3) {
            switch (item.tax_status) {
                case 0:
                    str = '#08BD06';
                    break;
                case '00':
                    str = '#08BD06';
                    break;
                case 2:
                    str = '#FF1A42';
                    break;
                case 3:
                    str = '#FF1A42';
                    break;
                case 4:
                    str = '#FF1A42';
                    break;
                case 7:
                    str = '#FF991F';
                    break;
                case 8:
                    str = '#FF1A42';
                    break;
                case 80:
                    str = '#FF991F';
            }
        }
        if (item.document_status == 2) {
            str = '#08BD06';
            return str;
        }
        if (item.document_status == 6) {
            str = '#FF1A42';
            return str;
        }
        if (!this.is_open_verify && !this.is_open_check) {
            str = '#08BD06';
        }
        if (this.is_open_check) {
            switch (item.check_status) {
                case 0:
                    str = '#FF991F';
                    break;
                case 1:
                    str = '#5E6771';
                    break;
                case 2:
                    str = '#08BD06';
                    break;
                case 3:
                    str = '#FF991F';
                    break;
                case 4:
                    str = '#FF991F';
            }
        }
        if (this.is_open_verify && item.check_status == '2') {
            switch (item.verify_status) {
                case 0:
                    str = '#FF991F';
                    break;
                case 1:
                    str = '#5E6771';
                    break;
                case 2:
                    str = '#08BD06';
                    break;
                case 3:
                    str = '#FF991F';
                    break;
                case 4:
                    str = '#FF991F';
            }
        }
        if (this.is_open_verify && !this.is_open_check) {
            str = '#FF991F';
        }
        return str;
    };
    InvoiceInfoDialog.prototype.statusText = function (item) {
        var str = '';
        if (item.source == 3) {
            switch (item.tax_status) {
                case 0:
                    str = '开票成功';
                    break;
                case '00':
                    str = '开票成功';
                    break;
                case 2:
                    str = '发票无效：发票已作废';
                    break;
                case 3:
                    str = '发票无效：发票已冲红';
                    break;
                case 4:
                    str = '发票无效：发票获取异常';
                    break;
                case 7:
                    str = '发票部分红冲';
                    break;
                case 8:
                    str = '发票无效：发票已全额红冲';
                    break;
                case 80:
                    str = '系统检测到该发票已关联了待确认单冲红发票';
            }
            return str;
        }
        if (item.document_status == 2) {
            str = '客户已确认发票';
            return str;
        }
        if (item.document_status == 6) {
            str = '客户驳回  驳回原因：' + item.reject_reason;
            return str;
        }
        if (!this.is_open_verify && !this.is_open_check) {
            str = item.status_name;
        }
        if (this.is_open_check) {
            switch (item.check_status) {
                case 0:
                    if (this.detail.from_system == 1) {
                        str = '该发票为客户系统同步，未进行发票识别';
                    }
                    else {
                        str = '发票OCR未识别';
                    }
                    break;
                case 1:
                    str = '发票OCR校验中…';
                    break;
                case 2:
                    str = '校验通过';
                    break;
                case 3:
                    str = item.check_result;
                    break;
                case 4:
                    str = item.check_result;
            }
        }
        if (this.is_open_verify && item.check_status == '2') {
            switch (item.verify_status) {
                case 0:
                    str = '发票未验真';
                    break;
                case 1:
                    str = '发票验真中…';
                    break;
                case 2:
                    str = '验真通过';
                    break;
                case 3:
                    str = item.verify_result;
                    break;
                case 4:
                    str = item.verify_result;
            }
        }
        if (this.is_open_verify && !this.is_open_check) {
            str = '当前客户未应用OCR发票识别服务，请先设置应用客户';
        }
        return str;
    };
    InvoiceInfoDialog.prototype.changeInvoiceMore = function () {
        this.isShowInvoice = !this.isShowInvoice;
    };
    InvoiceInfoDialog.prototype.copyInvoiceInfo = function (name) {
        var _this = this;
        var text = _this.invoice_info && _this.invoice_info[name] || '';
        if (!navigator.clipboard) {
            var textArea = document.createElement("textarea");
            textArea.value = text;
            textArea.style.position = "fixed";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            document.execCommand("copy");
            document.body.removeChild(textArea);
            _this.$message.success("已复制剪贴板");
            return;
        }
        navigator.clipboard.writeText(text).then(function () {
            _this.$message.success("已复制剪贴板");
        }, function () {
            _this.$message.success("复制失败");
        });
    };
    InvoiceInfoDialog.prototype.getOrderDocumentList = function () {
        var _this_1 = this;
        var loadingInstance;
        if (this.isFirstLoad) {
            loadingInstance = Loading.service({ fullscreen: true });
        }
        var param = {};
        if (this.type === 'edit') {
            param = {
                order_id: this.detail.order_id
            };
        }
        else {
            param = {
                supplier_to_business_id: this.detail.supplier_to_business_id
            };
        }
        this.service.getOrderDocumentList(param).then(function (res) {
            _this_1.isFirstLoad = false;
            loadingInstance && loadingInstance.close();
            var data = res.data;
            if (data.success) {
                _this_1.totalMoney = data.total_money;
                _this_1.invoiceList = (data.data || []);
                _this_1.is_open_verify = data.is_open_verify;
                _this_1.is_open_check = data.is_open_check;
                var incompleteList_1 = [];
                _this_1.invoiceList.forEach(function (item) {
                    if (!(item.document_status == 2 || item.document_status == 6)) {
                        if (_this_1.is_open_check && !_this_1.is_open_verify) {
                            if (item.check_status == 1) {
                                incompleteList_1.push(item);
                            }
                        }
                        if (_this_1.is_open_verify && _this_1.is_open_check) {
                            if (item.check_status == 1) {
                                incompleteList_1.push(item);
                            }
                            else {
                                if (item.check_status == '2' && item.verify_status == 1) {
                                    incompleteList_1.push(item);
                                }
                            }
                        }
                    }
                });
                if (incompleteList_1.length === 0 && _this_1.timer) {
                    clearInterval(_this_1.timer);
                }
            }
        }).catch(function (err) {
            _this_1.isFirstLoad = false;
            loadingInstance && loadingInstance.close();
            _this_1.$message.error(err.msg || err.message);
        });
    };
    InvoiceInfoDialog.prototype.beforUpload = function (file) {
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (!(fileType && (fileType == "jpeg" || fileType == 'jpg' || fileType == "png" || fileType == "pdf" || fileType == "ofd"))) {
            this.$message.error("上传文件不符合格式，只能jpeg、jpg、png、pdf、ofd格式");
            return false;
        }
        ;
        var isLtMaxSize = file.size / 1024 / 1024 < this.maxSize;
        if (!isLtMaxSize) {
            this.$message({
                showClose: true,
                message: "单个文件不能超过 " + this.maxSize + "MB!",
                type: 'error'
            });
            return false;
        }
    };
    InvoiceInfoDialog.prototype.exceedLimit = function (files, fileList) {
        this.$message({
            showClose: true,
            message: "最多上传" + (this.limit) + "张发票",
            type: 'error'
        });
    };
    InvoiceInfoDialog.prototype.uploadError = function (err, file, fileList) {
        this.$message.error(err.msg || err.message || "网络异常，请重新上传");
        this.loadingInstanceAll.close();
    };
    InvoiceInfoDialog.prototype.uploadSuccess = function (response, file, fileList) {
        var _this_1 = this;
        this.loadingInstanceAll = Loading.service({ fullscreen: true });
        if (response.success) {
            var params = {
                order_document: JSON.stringify([{ url: response.data.full_path, text: response.data.file_name }]),
                order_id: this.type == 'edit' ? this.detail.order_id : null,
                supplier_to_business_id: this.detail.supplier_to_business_id
            };
            this.service.updateInvoice(params).then(function (res) {
                _this_1.loadingInstanceAll.close();
                _this_1.getOrderDocumentList();
                if (_this_1.timer) {
                    clearInterval(_this_1.timer);
                }
                ;
                _this_1.timer = setInterval(function () {
                    _this_1.getOrderDocumentList();
                }, 3000);
            }).catch(function (err) {
                _this_1.loadingInstanceAll.close();
                _this_1.$message.error(err.message || err.msg);
            });
        }
        else {
            this.$message.error(response.msg);
        }
    };
    InvoiceInfoDialog.prototype.uploadReSuccess = function (response, file, fileList) {
        var _this_1 = this;
        if (response.success) {
            var params = {
                order_document: JSON.stringify([{ url: response.data.full_path, text: response.data.file_name }]),
                order_id: this.type == 'edit' ? this.detail.order_id : null,
                order_document_id: this.currentDocumentId,
                supplier_to_business_id: this.detail.supplier_to_business_id
            };
            this.service.updateInvoice(params).then(function (res) {
                if (res.data.code == 0) {
                    _this_1.getOrderDocumentList();
                    if (_this_1.timer) {
                        clearInterval(_this_1.timer);
                    }
                    ;
                    _this_1.timer = setInterval(function () {
                        _this_1.getOrderDocumentList();
                    }, 3000);
                }
                ;
            }).catch(function (err) {
                _this_1.$message.error(err.message || err.msg);
            });
        }
        else {
            this.$message.error(response.msg);
        }
    };
    InvoiceInfoDialog.prototype.removeInvoice = function (item) {
        var _this_1 = this;
        this.$confirm('请确认是否删除').then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this_1.service.deleteOrderDocument({
                order_id: _this_1.detail.order_id,
                order_document_id: item.document_id
            })
                .then(function (res) {
                loadingInstance.close();
                if (res.data.code === 0) {
                    _this_1.$message.success('删除成功');
                    _this_1.getOrderDocumentList();
                }
                else {
                    _this_1.$message.error(res.data.msg || '删除失败');
                }
            })
                .catch(function (err) {
                loadingInstance.close();
                _this_1.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    InvoiceInfoDialog.prototype.renameInvoice = function (item) {
        this.currentInvoice = item;
        this.renameText = item.document_name;
        this.renameDialogVisible = true;
    };
    InvoiceInfoDialog.prototype.renameSubmit = function () {
        var _this_1 = this;
        if (this.renameText.trim() == '') {
            this.$message.info('请输入发票名称');
            return;
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.renameOrderDocument({
            order_id: this.currentInvoice.order_id,
            order_document_id: this.currentInvoice.document_id,
            document_name: this.renameText
        })
            .then(function (res) {
            loadingInstance.close();
            if (res.data.code === 0) {
                _this_1.$message.success('重命名成功');
                _this_1.renameDialogVisible = false;
                _this_1.getOrderDocumentList();
            }
            else {
                _this_1.$message.error(res.data.msg || '重命名失败');
            }
        })
            .catch(function (err) {
            loadingInstance.close();
            _this_1.$message.error(err.msg || err.message);
        });
    };
    InvoiceInfoDialog.prototype.downAllInvoice = function () {
        if (this.invoiceList.length == 0) {
            return;
        }
        var order_id = this.detail.order_id ? this.detail.order_id : '';
        var url = "supplierclientapi/statementorder/download_order_document?order_id=" + order_id + '&supplier_to_business_id=' + this.detail.supplier_to_business_id + '&token=' + this.token;
        location.href = url;
    };
    InvoiceInfoDialog.prototype.downInvoice = function (item) {
        var name = item.document_name, url = item.document_pic;
        if (!name.includes('.')) {
            name = name + "." + url.slice(-3);
        }
        saveAs(url.replace(/(http:|https:)([\w\W]+)/, location.protocol + '$2'), name);
    };
    InvoiceInfoDialog.prototype.getCurrentDocumentId = function (document_id) {
        this.currentDocumentId = document_id;
    };
    InvoiceInfoDialog.prototype.close = function () {
        this.$emit('submitSuccess');
        this.$closeDialog();
    };
    InvoiceInfoDialog.prototype.submit = function (money_confirm) {
        var _this_1 = this;
        if (this.isEdit) {
            return this.saveInvoiceInfo();
        }
        if (this.invoiceList.length == 0) {
            this.$closeDialog();
            this.$emit('submitSuccess', cloneDeep(this.invoice_info));
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        var param = {
            order_id: this.detail.order_id
        };
        if (money_confirm && money_confirm == 1) {
            param = Object.assign(param, { money_confirm: 1 });
        }
        if (money_confirm && money_confirm == 2) {
            param = Object.assign(param, { confirm_diff_tax_money: 1 });
        }
        this.service.confirmOrderDocument(param).then(function (res) {
            console.log('submit>>>', param);
            loadingInstance.close();
            if (res.data.code == 80) {
                _this_1.$alert('发票校验未通过，请核对发票', '提示', {
                    confirmButtonText: '确定',
                    callback: function (action) {
                    }
                });
            }
            else if (res.data.code == 78) {
                _this_1.$confirm('开具发票金额与账单金额不一致，是否继续提交？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    _this_1.submit(1);
                }).catch(function () {
                });
            }
            else if (res.data.code == 82) {
                _this_1.$confirm("\u53D1\u7968\u603B\u7A0E\u989D\u548C\u8D26\u5355\u5E94\u5F00\u7968\u603B\u7A0E\u989D\u5B58\u5728\u5DEE\u5F02\uFF0C\u5BA2\u6237\u8981\u6C42\u5DEE\u5F02\u4E0D\u8D85\u8FC7 " + res.data.data.tax_money_diff + "\u5143\uFF0C\u662F\u5426\u7EE7\u7EED\u63D0\u4EA4\uFF1F", '提示', {
                    confirmButtonText: '确认提交',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    _this_1.submit(2);
                }).catch(function () {
                });
            }
            else if (res.data.code === 0) {
                _this_1.$message.success(res.data.msg || '发票提交成功');
                _this_1.$closeDialog();
                _this_1.$emit('submitSuccess', cloneDeep(_this_1.invoice_info));
            }
            else {
                _this_1.$message.error(res.data.msg || '重命名失败');
            }
        })
            .catch(function (err) {
            loadingInstance.close();
            _this_1.$message.error(err.msg || err.message);
        });
    };
    InvoiceInfoDialog.prototype.querySearch = function (queryString, cb) {
        var _this_1 = this;
        if (!/^\s*$/.test(queryString) && queryString.length >= 3) {
            this.service.getCompanyByKeyword({
                keyword: queryString
            }).then(function (res) {
                console.log('querySearch res>>>', res);
                if (res.data.code === 0) {
                    var results = res.data.data.map(function (item) {
                        return {
                            value: item.company_name,
                            code: item.company_license_code
                        };
                    });
                    cb(results);
                }
            }).catch(function (err) {
                _this_1.$message.error(err.msg || err.message);
            });
        }
        else {
            cb([]);
        }
    };
    InvoiceInfoDialog.prototype.handleSelect = function (item) {
        var _this_1 = this;
        this.invoiceForm.taxnumber = item.code;
        this.service.getCompanyInfo({ company_name: item.value })
            .then(function (res) {
            console.log('res>>>', res);
            if (res.data.success) {
                var data = res.data.data || {};
                _this_1.invoiceForm.bank = data.bank;
                _this_1.invoiceForm.banknumber = data.bankAccount;
                _this_1.invoiceForm.address = data.location;
                _this_1.invoiceForm.business_address = data.location;
                _this_1.invoiceForm.phone = data.fixedPhone;
                _this_1.invoiceForm.contacts = '';
            }
            else {
                _this_1.invoiceForm.taxnumber = '';
                _this_1.invoiceForm.bank = '';
                _this_1.invoiceForm.banknumber = '';
                _this_1.invoiceForm.address = '';
                _this_1.invoiceForm.business_address = '';
                _this_1.invoiceForm.phone = '';
                _this_1.invoiceForm.contacts = '';
            }
        }).catch(function (err) {
            _this_1.$message.error(err.msg || err.message);
        });
    };
    InvoiceInfoDialog.prototype.editInvoice = function (isEdit) {
        this.isEdit = isEdit;
        if (isEdit) {
            this.invoiceForm = cloneDeep(this.invoice_info);
        }
        else {
            this.invoiceForm = {};
        }
    };
    InvoiceInfoDialog.prototype.saveInvoiceInfo = function () {
        var _this_1 = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.updateInvoiceInfo(__assign({ order_id: this.detail.order_id }, this.invoiceForm)).then(function (res) {
            loadingInstance.close();
            if (res.data.code === 0) {
                _this_1.$message.success('保存成功');
                _this_1.invoice_info = cloneDeep(_this_1.invoiceForm);
                _this_1.editInvoice(false);
                if (!_this_1.detail.order_id) {
                    _this_1.$emit('submitSuccess', cloneDeep(_this_1.invoice_info));
                }
            }
            else {
                _this_1.$message.error(res.data.msg || '保存失败');
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this_1.$message.error(err.msg || err.message);
        });
    };
    InvoiceInfoDialog.prototype.mounted = function () {
    };
    InvoiceInfoDialog.prototype.destroyed = function () {
        clearInterval(this.timer);
    };
    InvoiceInfoDialog = __decorate([
        Component({
            computed: {
                previewImgList: function () {
                    var list = this.invoiceList.filter(function (item) {
                        var type = item.document_pic.slice(-3).toLowerCase();
                        return !['pdf', 'ofd'].includes(type);
                    });
                    return list.map(function (item) { return item.document_pic; });
                },
                canEdit: function () {
                    return this.detail.is_confirm != 2;
                },
                showEdit: function () {
                    if (this.detail.from_system == 1) {
                        return !this.invoice_info.name || !this.invoice_info.taxnumber;
                    }
                    else if (this.detail.has_baiwangyun_document == 1) {
                        return false;
                    }
                    else {
                        return this.detail.order_status == 0;
                    }
                },
                canOperateDocument: function () {
                    return this.parentPageAuth.Invoice && !(this.detail.order_status === this.statusList['已废弃'] || this.detail.order_status === this.statusList['反审核']);
                },
                canAuditOperateDocument: function () {
                    return this.parentPageAuth.Invoice && !(this.detail.order_status === this.statusList['已废弃'] || this.detail.order_status === this.statusList['反审核']);
                },
                showBillButton: function () {
                    return (this.detail.order_status == 7 || this.detail.order_status == 2) && this.detail.is_confirm == 1 && this.detail.can_create_docuemnt == 1;
                },
                showUploadButton: function () {
                    return (this.detail.order_status == 0
                        || this.detail.order_status == 1
                        || this.detail.order_status == 7
                        || (this.detail.order_status == 2 && this.detail.is_confirm == 0)
                        || this.detail.is_confirm == 1
                        || this.detail.can_create_docuemnt == 0);
                }
            }
        })
    ], InvoiceInfoDialog);
    return InvoiceInfoDialog;
}(IVueDialog));
export default InvoiceInfoDialog;
